import { all } from 'redux-saga/effects';

export function combineAllWatchers(watchers: (() => Generator)[]) {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	return function* combinedWatcherSaga() {
		const activeWatchers = watchers.map((watcher) => watcher());

		return yield all(activeWatchers);
	};
}
